<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="万里牛仓库" :width="800" :index="0" @hide="hide"
		@submit="submit" moduleName="sourcebill" :store="store" selectType="radio" @boxdataload="boxdataload" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			type: {
				default: () => {
					return null
				}
			},

		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						field: 'storageName',
						title: '名称',
						render: '',
						props: {
							
						},

					},{
						field: 'mobile',
						title: '手机',
						render: '',
						props: {
							
						}
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: false,
						pageSizes: [10, 20, 50, 200],
						force: false
					},
				},
			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show

			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				if (this.box.getTable()) {
					let form = this.box.getTable().getProxyInfo().form
					for (let i in form) {
						form[i] = null
					}
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				return new Promise((resolve, reject) => {
					this.$api.relation.listwarehouse({
						...{plant:'wln'},
						...page,
						...form,
						...other
					}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.box.getTable().reloadData([])
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>